import React, { useEffect, useState, useContext, useRef } from 'react';
import { Button, Modal, Carousel, Spinner, Form } from 'react-bootstrap';
import { GetPayLoad } from "../services/PayLoadStorage";
import { LanguageContext } from "../contexts/LanguageContext";
import { getApiService } from "../services/ApiService";
import previousarrow from "../assets/images/icons/Previous-Arrow.svg";
import nextarrow from "../assets/images/icons/Next-arrow.svg";
import zap from "../assets/images/icons/zap.svg";
import zapBCBSAZ from "../assets/images/icons/zap-BCBSAZ.svg";
import Cookies from "js-cookie";
import ActivateAccountModal from "../components/activateAccountModal.jsx";
import SwitchToEbillModal from "../components/switchToEbillModal.jsx";
import SwitchToPaperModal from "./switchToPaperModal.jsx";
import Forms from "../components/forms";
import { toast } from "react-toastify";
import { handleFiservLogin } from '../services/FiservLoginService.jsx';
import "../styles/billingPreferenceResponsive.css";

const BillingPreference = ({ show, handleClose, caseInfo, sendDataToCard }) => {
  
    const Payload = GetPayLoad("PayLoad");
    const { pageContent } = useContext(LanguageContext);
    const tab1Ref = useRef(null);
    const tab2Ref = useRef(null);
    const tab3Ref = useRef(null);
    
    const [apiCallCompleted, setApiCallCompleted] = useState(false);
    const [billingContent, setBillingContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const [activeKey, setActiveKey] = useState("tab1");
    const [billingPreference, setBillingPreference] = useState([]);
    const [isPrefLoading, setPrefLoading] = useState(true);
    const [currentBilling, setCurrentBilling] = useState([]);
    const [billingPrefErrorFlag, setBillingPrefErrorFlag] = useState(false);
    const [activeAccounts, setActiveAccounts] = useState([]);
    const [isActiveLoading, setActiveLoading] = useState(true);
    const [activateModal, setActivateModal] = useState(false);
    const [vaultId, setVaultId] = useState();
    const [accountType, setAccountType] = useState();
    const [eBillModal, setEBillModal] = useState(false);
    const [paperModal, setPaperModal] = useState(false);
    const [accountNumber, setAccountNumber] = useState();
    const [accountName, setAccountName] = useState();
    const [address, setAddress] = useState([]);
    const [addNew, setAddNew] = useState(false);
    const [eMail, setEmail] = useState('');
    const [open, setOpen] = useState(false);
    const [hidePaperOption, setHidePaperOption] = useState(false);
    const [hideEbillOption, sethideEbillOption] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [vaultImgSrc, setVaultImgSrc] = useState('');
    const [ebillImgSrc, setEbillImgSrc] = useState('');
    const [paperImgSrc, setPaperImgSrc] = useState('');

    const slideRefs = useRef([]);
    const [active, setActive] = useState(0);
    
    // Determine which zap icon to use based on carrier
    const zapIcon = Payload?.owning_carrier === 'Q5' ? zapBCBSAZ : zap;

    const isQ5 = Payload?.owning_carrier === 'Q5';
    const visibleAccountsCount = isQ5
        ? activeAccounts.filter(item =>
            !(item?.cardType === 'CCD' && Cookies.get('binder_payment_flag') === 'false')
          ).length
        : activeAccounts.length;
    const hideCarouselArrows = isQ5 && visibleAccountsCount <= 1;

    const switchBillPaperButton = () => {
    switch (Payload?.owning_carrier) {
        case 'CG':
            return 'btn-outline-success';
        case 'Q5':
            return 'btn-outline-secondary';
        case 'X6':
            return 'btn-primary';
        default:
            return 'btn-outline-success';
    }
};

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
      "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
      "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
      "X-Hps-Region": Payload?.region,
      "X-Hps-Carrier": Payload?.owning_carrier,
    };

    const [readOnlyMode, setReadOnlyMode] = useState(false);

    useEffect(() => {

        // Check for read-only mode based on owning carrier or any other condition
        setReadOnlyMode(Payload?.readOnlyAccess === true);

        if (pageContent?.billing) {
          setBillingContent(pageContent.billing);
        }
    
        if (pageContent?.generic) {
          setGenericContent(pageContent.generic);
        }

         // Set address and email from caseInfo if available
        if (caseInfo && caseInfo?.mailAddress) {
            setAddress(caseInfo?.mailAddress);
        }
        if (caseInfo && caseInfo?.email) {
            setEmail(caseInfo?.email);
        }
        
        if(Payload?.owning_carrier !== "Q5"){
          const imageCarrierCode = Cookies.get('isConnectiCareCarrier') === 'true' ? Cookies.get('connectiCareCarrier') : Cookies.get('owningCarrier');
          import('../assets/images/Illustrations/Vault-'+imageCarrierCode+'.svg').then((image) => {
            setVaultImgSrc(image.default);
          });

          import('../assets/images/Illustrations/Ebill-'+imageCarrierCode+'.svg').then((image) => {
            setEbillImgSrc(image.default);
          });

          import('../assets/images/Illustrations/Paper-'+imageCarrierCode+'.svg').then((image) => {
            setPaperImgSrc(image.default);
          });
        }

        fetchApiData();
    }, [pageContent]);

    useEffect(() => {
      const el = slideRefs.current[active];
      el?.focus();
      
      if (apiCallCompleted && !isInitialLoad) {
          let tabRef;
          if (activeKey === "tab1") tabRef = tab1Ref;
          else if (activeKey === "tab2") tabRef = tab2Ref;
          else if (activeKey === "tab3") tabRef = tab3Ref;

          if (tabRef?.current) {
              // Use requestAnimationFrame for better timing
              requestAnimationFrame(() => {
                  if (tabRef.current) {
                      tabRef.current.focus({ preventScroll: true });
                  }
              });
          }
      }
    }, [active, activeKey, apiCallCompleted, isInitialLoad]);
        
    const gotoPrev = () => setActive(i => (i - 1 + activeAccounts.length) % activeAccounts.length);
    const gotoNext = () => setActive(i => (i + 1) % activeAccounts.length);

    const onKeyDown = (e) => {
      if (e.key === "ArrowRight") { e.preventDefault(); gotoNext(); }
      if (e.key === "ArrowLeft")  { e.preventDefault(); gotoPrev(); }
    };

    const fetchApiData = () => {
        setIsInitialLoad(false);
        const targetGetActiveAccountsUrl =
        process.env.REACT_APP_API_GET_ACTIVE_ACCOUNTS_ENDPOINT;
        getApiService(
            baseUrl,
            targetGetActiveAccountsUrl,
            { cim: Payload?.cim, request: "1" },
            headers
        )
        .then((response) => {
        setActiveLoading(false);
        if (response?.data?.statusCode !== 200) {
            setBillingPrefErrorFlag(true);
        } else {
            setBillingPrefErrorFlag(false);
            const result = response.data.data;
            setActiveAccounts(result);
        }
        })
        .catch((error) => {
        setActiveLoading(false);
        setBillingPrefErrorFlag(true);
        });

        const targetBillingPreferenceUrl =
            process.env.REACT_APP_API_GET_BILL_PREFERENCE_ENDPOINT;
        getApiService(
            baseUrl,
            targetBillingPreferenceUrl,
            { cim: Payload?.cim },
            headers
        )
            .then((response) => {
                if (response?.data && response?.data?.status === "SUCCESS") {
                    const result = response.data.data;
                    setBillingPreference(result);
                    setPrefLoading(false);
                    if (
                    result?.CurrentBillType === "WEBPORTAL" &&
                    (result?.CurrentBillPref === "P6" ||
                        result?.CurrentBillPref === "P7")
                    ) {
                    setCurrentBilling("AutomatedBilling");
                    } else if (
                    result?.CurrentBillPref === "P5" &&
                    result?.CurrentBillType === "WEBPORTAL"
                    ) {
                    setCurrentBilling("Ebill");
                    } else {
                    setCurrentBilling("Paper");
                    }
                    setApiCallCompleted(true);
                }
            })
            .catch((error) => {
                console.error("Error fetching billing preference data:", error);
            });

      const targetGetCaseTypesUrl = process.env.REACT_APP_API_CASE_TYPE_DTL_ENDPOINT;
        getApiService(baseUrl, targetGetCaseTypesUrl, { cim: Payload?.cim, case_num: Payload?.case_num, request: '1', "sitecd": Payload?.site_cd }, headers)
        .then((response) => {
            if (response?.data && response?.data?.status === 'SUCCESS') {
                const result = response.data.data;
                setHidePaperOption(result?.setHidePaperOption);
                sethideEbillOption(result?.setHideEbillOption);
                console.log("setHidePaperOption==>"+result?.setHidePaperOption);
               
            } else {
                setHidePaperOption('');
                sethideEbillOption('');
               
            }
        })
        .catch(error => {
            console.error('Error fetching case type:', error);
        });
    }

    const getCurrentBilling = (currentBilling) => {
        if (currentBilling === "AutomatedBilling") {
          return billingContent?.billing_pref_automated_billing_text;
        } else if (currentBilling === "Ebill") {
          return billingContent?.billing_pref_ebill_text;
        } else {
          return billingContent?.billing_pref_paper_text;
        }
      };

    // This is handler for Manage AutoPay button click
    const handleManageAutoPayPref = () => {
        if (Cookies.get("owningCarrier") === "C4") {
        // For Fiserv Carrier Molina, directly call the Fiserv login API and redirect to Fiserv portal
        handleFiservLogin();
        }
    };

    const handleActivateModal = (
        modal,
        accNumber,
        accName,
        vaultId,
        accountType
      ) => {
        setActivateModal(true);
        setAccountNumber(accNumber);
        setAccountName(accName);
        setVaultId(vaultId);
        setAccountType(accountType);
    };

    const handleAddNew = (e) => {
        e.preventDefault();
        setAddNew(true);
    };

    const handleEBillModal = () => {
    setEBillModal(true);
    };
    const handlePaperModal = () => {
    setPaperModal(true);
    };
    const handleCloseEbillModal = () => {
    setEBillModal(false);
    };
    const handleCancelRequest = () => {
    setPaperModal(false);
    };

    const handleCloseModal = () => {
        setAddNew(false);
    };

  function handleDataFromModal(message, tabKey, response) {
    if (message !== "") {
      if (response === "success") {
        toast.success(message);
        tabKey === 'tab1' ? sendDataToCard('Disable') : sendDataToCard('Enable');
      } else {
        toast.error(message);
      }
    }
    setApiCallCompleted(false);
    setPrefLoading(true);
    setActiveLoading(true);
    fetchApiData();
    setActiveKey(tabKey);
  }

  function handleAddNewDataForm(message, response) {
    if (message !== "") {
      if (response === "success") {
        toast.success(message);
      } else {
        toast.error(message);
      }
    }
    setApiCallCompleted(false);
    setPrefLoading(true);
    setActiveLoading(true);
    fetchApiData();
    setActiveKey("tab1");
  }
  // Set Active Tab Based on Button Click
  const handleTabClick = (tabKey) => {
      setActiveKey(tabKey);
  };

  const handleFocus = (e) => {
    setActive(0);
  }

    return (
        <>
        <Modal size="lg" show={activateModal}>
        <ActivateAccountModal
          accountNumber={accountNumber}
          accountName={accountName}
          vaultId={vaultId}
          accountType={accountType}
          setActivateModal={setActivateModal}
          sendDataToParent={handleDataFromModal}
        />
      </Modal>

      {eBillModal && (
        <Modal
          size="x1"
          show={eBillModal}
          onHide={() => {
            setEBillModal();
          }}
        >
          <SwitchToEbillModal
            handleCloseEbillModal={handleCloseEbillModal}
            eMail={caseInfo?.email??""}
            sendDataToParent={handleDataFromModal}
            hideEbillOption={hideEbillOption}
          />
        </Modal>
      )}

      {paperModal && (
        <Modal
          size="x1"
          show={paperModal}
          onHide={() => {
            setPaperModal();
          }}
        >
          <SwitchToPaperModal
            handleCancelRequest={handleCancelRequest}
            setPaperModal={setPaperModal}
            address={address}
            sendDataToParent={handleDataFromModal}
            hidePaperOption={hidePaperOption}
          />
        </Modal>
      )}
        <div>
        <Modal.Header className={`modal-header ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>

          {/* Mobile Dropdown for Q5 Carrier */}
          {Payload?.owning_carrier === 'Q5' && (
            <div className="d-block d-md-none w-100 pb-3" style={{ paddingRight: '40px' }}>
              <label
                htmlFor="billing-pref-tab-select"
                className="q5-payment-type-label"
                id="billing-pref-tab-select-label"
              >
                Billing Preference
              </label>
              <Form.Select
                id="billing-pref-tab-select"
                value={activeKey}
                onChange={(e) => handleTabClick(e.target.value)}
                aria-label="Select billing preference type to view automated billing, e-bill, or paper bill"
                aria-labelledby="billing-pref-tab-select-label"
                className="payment-type-select"
                tabIndex={0}
              >
                <option value="tab1">
                  {billingContent?.billing_automated_billing_title || 'Automated Billing'}
                </option>
                <option value="tab2">
                  {billingContent?.billing_ebill_title || 'E-Bill'}
                </option>
                <option value="tab3">
                  {billingContent?.billing_paper_title || 'Paper Bill'}
                </option>
              </Form.Select>
            </div>
          )}

          {/* Tab Navigation (Hidden on mobile for Q5, Always shown for other carriers) */}
          <div className={`nav nav-tabs ${Payload?.owning_carrier === 'Q5' ? 'd-none d-md-flex' : ''}`} id="nav-tab" role="tablist" tabIndex={0}>

            <button className={`nav-link ${activeKey === 'tab1' ? 'active' : ''} me-xl-3`} 
            id="nav-billing-tab" data-bs-toggle="tab" data-bs-target="#nav-billing" aria-live="polite" type="button" 
            role="tab" aria-controls="nav-billing-tab"  aria-selected={activeKey === 'tab1'}
            onClick={() => handleTabClick('tab1')}
            onKeyDown={(e) => {
                if (e.key === 'ArrowRight') {
                  e.preventDefault();
                  document.getElementById('nav-Ebill-tab')?.focus();
                }
              }}
              onFocus={handleFocus}
              >
              <span className="me-2">
                {billingContent?.billing_automated_billing_title || 'Automated Billing'}
              </span>
              {billingPreference?.CurrentBillType === "WEBPORTAL" &&
              (billingPreference?.CurrentBillPref === "P6" ||
              billingPreference?.CurrentBillPref === "P7") && (
              <img src={zapIcon} alt="Zap Icon" />
              )}
            </button>

            <button className={`nav-link ${activeKey === 'tab2' ? 'active' : ''} me-xl-3`} 
            id="nav-Ebill-tab" data-bs-toggle="tab" data-bs-target="#nav-Ebill" aria-live="polite" 
            type="button" role="tab" aria-controls="nav-Ebill" aria-selected={activeKey === 'tab2'}
            onClick={() => handleTabClick('tab2')}
            onKeyDown={(e) => {
                if (e.key === 'ArrowLeft') {
                  e.preventDefault();
                  document.getElementById('nav-billing-tab')?.focus();
                } else if (e.key === 'ArrowRight') {
                  e.preventDefault();
                  document.getElementById('nav-Paper-tab')?.focus();
                }
              }}>
              <span className="me-2">
                {billingContent?.billing_ebill_title || 'E-Bill'}
              </span>
              {billingPreference?.CurrentBillPref === "P5" &&
              billingPreference?.CurrentBillType === "WEBPORTAL" && (
              <img src={zapIcon} alt="Zap Icon" />
              )}
            </button>

            <button className={`nav-link ${activeKey === 'tab3' ? 'active' : ''} me-xl-3`} 
            id="nav-Paper-tab" data-bs-toggle="tab" 
            data-bs-target="#nav-Paper" aria-live="polite" type="button" role="tab" 
            aria-controls="nav-Paper" 
            aria-selected={activeKey === 'tab3'}
            onClick={() => handleTabClick('tab3')}
            onKeyDown={(e) => {
                if (e.key === 'ArrowLeft') {
                  e.preventDefault();
                  document.getElementById('nav-Ebill-tab')?.focus();
                }
              }}>
              <span className="me-2">
                {billingContent?.billing_paper_title || 'Paper Bill'}
              </span>
              {billingPreference?.CurrentBillPref === "P5" &&
              billingPreference?.CurrentBillType === "PAPER" && (
              <img src={zapIcon} alt="Zap Icon" />
              )}
            </button>
          </div>

          {/* <Tabs
            id="modal-tabs"
            activeKey={activeKey}
            onSelect={(k) => setActiveKey(k)}
            className=" tab-spacing"
          >
            <Tab
              eventKey="tab1"
              title={
                <>
                  <span className="me-2">
                    {billingContent?.billing_automated_billing_title || 'Automated Billing'}
                  </span>
                  {billingPreference?.CurrentBillType === "WEBPORTAL" &&
                    (billingPreference?.CurrentBillPref === "P6" ||
                      billingPreference?.CurrentBillPref === "P7") && (
                      <img src={zap} alt="Zap Icon" />
                    )}
                </>
              }
            ></Tab>
            <Tab
              eventKey="tab2"
              title={
                <>
                  <span className="me-2">
                    {billingContent?.billing_ebill_title || 'E-Bill'}
                  </span>
                  {billingPreference?.CurrentBillPref === "P5" &&
                    billingPreference?.CurrentBillType === "WEBPORTAL" && (
                      <img src={zap} alt="Zap Icon" />
                    )}
                </>
              }
            ></Tab>
            <Tab
              eventKey="tab3"
              title={
                <>
                  <span className="me-2">
                    {billingContent?.billing_paper_title || 'Paper Bill'}
                  </span>
                  {billingPreference?.CurrentBillPref === "P5" &&
                    billingPreference?.CurrentBillType === "PAPER" && (
                      <img src={zap} alt="Zap Icon" />
                    )}
                </>
              }
            ></Tab>
          </Tabs> */}
        </Modal.Header>
        <Modal.Body>
          <div class="bd-example">
							<div class="nav-billings">
          {activeKey === "tab1" && (
            <div
              ref={tab1Ref}
              tabIndex="-1"
              style={{ outline: 'none' }}
              className="tab-pane fade show active"
              id="nav-billing"
              role="tabpanel"
              aria-labelledby="nav-billing-tab"
              aria-label="Automated Billing Content"
              onKeyDown={(e) => {
                    // Handle Shift+Tab to go back to tabs
                    if (e.key === 'Tab' && e.shiftKey) {
                      e.preventDefault();
                      document.getElementById('nav-billing-tab')?.focus();
                    }
                  }}
            >
              {billingPrefErrorFlag && (
                <div className="api-error-msg">
                  {genericContent?.billing_pref_info_service_error}
                </div>
              )}
              {isPrefLoading && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    margin: "inherit",
                  }}
                >
                  <Spinner animation="border" role="status"></Spinner>
                  <div style={{ fontSize: "12px" }}>
                    {genericContent?.loading_message}
                  </div>
                </div>
              )}
              {!isPrefLoading && !billingPrefErrorFlag && (
                <div className="mb-4" tabIndex={active === 0 ? 0 : -1}>
                  <img src={zapIcon} className="me-2" alt="Active-Pay" />
                  <h6 className="d-inline">
                    {billingContent?.billing_current_preference}{" "}
                    {getCurrentBilling(currentBilling)}
                  </h6>
                </div>
              )}
              <div className="col-12 d-xl-flex d-md-flex d-sm-block d-block">
                <div
                  className={
                    Payload?.owning_carrier === "Q5"
                      ? "col-xl-12 col-sm-12 col-12"
                      : "col-xl-6 col-md-7 col-sm-12 col-12"
                  }
                >
                  <div className="grey-bg rounded px-4 py-4 mb-4 custom-rounded" tabIndex={active === 0 ? 0 : -1}>
                    <p>
                      <b>{billingContent?.billing_automated_billing_note}</b>{" "}
                      {billingContent?.billing_automated_billing_note_content}
                    </p>
                  </div>
                  <div
                    id="carouselExampleIndicators"
                    className="carousel slide"
                  >
                    {billingPrefErrorFlag && (
                      <div className="api-error-msg">
                        {genericContent?.accounts_info_service_error}
                      </div>
                    )}
                    {isActiveLoading && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                          margin: "inherit",
                        }}
                      >
                        <Spinner animation="border" role="status"></Spinner>
                        <div style={{ fontSize: "12px" }}>
                          {genericContent?.loading_message}
                        </div>
                      </div>
                    )}

                    <div className="">
                      {Cookies.get("hidePaymentSection") === "true" && (
                        <button
                          className="btn btn-primary"
                          onClick={() => handleManageAutoPayPref()}
                        >
                          {billingContent?.billing_pref_manage_pref_text}
                        </button>
                      )}
                      {Cookies.get("hidePaymentSection") !== "true" &&
                        !isActiveLoading &&
                        !billingPrefErrorFlag &&
                        activeAccounts && activeAccounts.length > 0 && (
                          <Carousel
                            interval={null}
                            indicators={false}
                            prevIcon={
                              hideCarouselArrows
                                ? null
                                : <img src={previousarrow} alt="previousarrow" onClick={gotoPrev} onKeyDown={onKeyDown} />
                            }
                            nextIcon={
                              hideCarouselArrows
                                ? null
                                : <img src={nextarrow} alt="nextarrow" onClick={gotoNext} onKeyDown={onKeyDown} />
                            }
                            className={`ezpay-carousel${hideCarouselArrows ? ' no-arrows' : ''}`}
                          >
                            {activeAccounts?.map((item, key) => {
                              let hideCreditCard =
                                Cookies.get("owningCarrier") === "Q5" &&
                                item?.cardType === "CCD" &&
                                Cookies.get("binder_payment_flag") === "false"
                                  ? true
                                  : false;

                              return (
                                !hideCreditCard && (
                                  <Carousel.Item>
                                    <div
                                      role="option"
                                      aria-live="polite"
                                      aria-atomic="true"
                                      tabIndex={key === active ? 0 : -1}
                                      aria-selected={key === active}
                                      ref={(el) => (slideRefs.current[key] = el)}
                                    >
                                      <div 
                                      className="col-xl-12 col-md-12 col-sm-12 d-xl-flex d-md-flex d-sm-flex d-block mb-3 px-2">
                                        <div 
                                        
                                        className="col-xl-4 col-md-4 col-sm-4 col-12 labels overflow-hidden text-truncate pe-2">
                                          <label className="label-heading d-block">
                                            {
                                              billingContent?.billing_automated_billing_account_name
                                            }
                                          </label>
                                          <label className="label-name fw-semibold d-block text-wrap text-break">
                                            {item?.accountName}
                                          </label>
                                        </div>
                                        <div
                                         className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels overflow-hidden text-truncate pe-2">
                                          <label className="label-heading d-block">
                                            {
                                              billingContent?.billing_automated_billing_account_type
                                            }
                                          </label>
                                          <label className="label-name fw-semibold d-block text-wrap text-break">
                                            {item?.detailedAccountType === "MC"
                                              ? billingContent?.billing_automated_billing_account_type_mc
                                              : (genericContent?.[
                                                "account_type_" +
                                                item?.detailedAccountType.toLowerCase()
                                              ] || item?.detailedAccountType)}
                                          </label>
                                        </div>
                                        <div className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels overflow-hidden text-truncate pe-2">
                                          <label className="label-heading d-block">
                                            {
                                              billingContent?.billing_automated_billing_account_number
                                            }
                                          </label>
                                          <label className="label-name fw-semibold d-block text-wrap text-break">
                                            {
                                              billingContent?.billing_automated_billing_account_number_mask
                                            }
                                            {item?.accountNumLastFour}
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-xl-12 col-md-12 col-sm-12 d-xl-flex d-md-flex d-sm-flex d-block mb-3 px-2">
                                        <div className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels overflow-hidden text-truncate pe-2">
                                          <label className="label-heading d-block">
                                            {
                                              billingContent?.billing_automated_billing_account_available_status
                                            }
                                          </label>
                                          <label className="label-name fw-semibold d-block text-wrap text-break">
                                            {item?.status === "Available"
                                              ? billingContent?.billing_automated_billing_available_text
                                              : ""}
                                          </label>
                                        </div>
                                        <div className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels overflow-hidden text-truncate pe-2">
                                          <label className="label-heading d-block">
                                            {
                                              billingContent?.billing_automated_billing_account_exp_date
                                            }
                                          </label>
                                          <label className="label-name fw-semibold d-block text-wrap text-break">
                                            {item?.ExpiryDate}
                                          </label>
                                        </div>
                                        <div className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels overflow-hidden text-truncate pe-2">
                                          <label className="label-heading d-block">
                                            {
                                              billingContent?.billing_automated_billing_account_status
                                            }
                                          </label>
                                          <label className="label-name fw-semibold d-block text-wrap text-break">
                                            {item?.activeStatus === "Y" ? (
                                              <button className="btn btn-success btn-md rounded-pill" tabIndex={-1}>
                                                {
                                                  billingContent?.billing_automated_billing_account_active
                                                }
                                              </button>
                                            ) : !readOnlyMode ? (
                                              <button
                                                id="btn1"
                                                className="btn btn-primary btn-md rounded-pill btn-active"
                                                data-bs-target="#makeactive"
                                                data-bs-toggle="modal"
                                                tabIndex={0}
                                                onClick={() =>
                                                  handleActivateModal(
                                                    "activate",
                                                    item?.accountNumLastFour,
                                                    item?.accountName,
                                                    item?.vaultId,
                                                    item?.accountType
                                                  )
                                                }
                                              >
                                                {
                                                  billingContent?.billing_automated_billing_account_make_active
                                                }
                                              </button>
                                            ) : (
                                              <span>N/A</span>
                                            )}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </Carousel.Item>
                                )
                              );
                            })}
                          </Carousel>
                        )}
                    </div>
                  </div>
                  {Cookies.get("hidePaymentSection") !== "true" && (
                    <div class="d-flex px-2 mt-4">
                      <h6>{billingContent?.billing_pref_add_account_msg}</h6>
                    {!readOnlyMode && ( 
                      <Button
                        variant="link"
                        className={Payload?.owning_carrier === 'Q5' 
                          ? "ms-3 anchor-text anchor-text-q5" 
                          : "text-decoration-underline ms-3 anchor-text"}
                        onClick={handleAddNew}
                      >
                        {billingContent?.billing_pref_add_account_text}
                      </Button>
                    )}
                      {addNew && (
                        <Modal
                          size="xl"
                          show={addNew}
                          onHide={() => {
                            setAddNew();
                          }}
                        >
                          <Forms
                            handleCloseModal={handleCloseModal}
                            caseInfo={caseInfo}
                            sendDataToParent={handleAddNewDataForm}
                          />
                        </Modal>
                      )}
                    </div>
                  )}
                  {/* <div className="text-decoration-underline ms-3 anchor-text"
                    data-bs-target="#exampleaddEFT" data-bs-toggle="modal" onClick={() => setOpen(true)}>
                    Add a New Account
                  </a>
                </div> */}
                  <Modal size="xl" show={open} onHide={() => setOpen(false)}>
                    <Forms onClose={() => setOpen(false)} />
                  </Modal>
                </div>
                {Payload?.owning_carrier !== "Q5" && (
                  <div className="col-xl-6 col-md-5 col-12">
                    <img src={vaultImgSrc} className="mw-100" alt="vault" />
                  </div>
                )}
              </div>
            </div>
          )}
          {activeKey === "tab2" && (
            <div
              ref={tab2Ref}
              tabIndex="-1"
              style={{ outline: 'none' }}
              className="tab-pane fade show"
              id="nav-Ebill"
              role="tabpanel"
              aria-labelledby="nav-Ebill-tab"
              aria-label="E-Bill Content"
              onKeyDown={(e) => {
                    if (e.key === 'Tab' && e.shiftKey) {
                      e.preventDefault();
                      document.getElementById('nav-Ebill-tab')?.focus();
                    }
                  }}
            >
              <div className="col-12 d-xl-flex d-md-flex d-sm-block d-block">
                <div
                  className={
                    Payload?.owning_carrier === "Q5"
                      ? "col-xl-12 col-sm-12 col-12"
                      : "col-xl-6 col-md-7 col-sm-12 col-12"
                  }
                >
                  {billingPrefErrorFlag && (
                    <div className="api-error-msg">
                      {genericContent?.billing_pref_info_service_error}
                    </div>
                  )}
                  {isPrefLoading && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        margin: "inherit",
                      }}
                    >
                      <Spinner animation="border" role="status"></Spinner>
                      <div style={{ fontSize: "12px" }}>
                        {genericContent?.loading_message}
                      </div>
                    </div>
                  )}
                  {!isPrefLoading && !billingPrefErrorFlag && (
                    <div tabIndex={0} className="mb-3">
                      <img src={zapIcon} className="me-2" alt="zap" />
                      <h6 className="d-inline">
                        {billingContent?.billing_current_preference}{" "}
                        {getCurrentBilling(currentBilling)}
                      </h6>
                    </div>
                  )}
                  <div tabIndex={0} className="grey-bg rounded px-4 py-4 mb-4">
                    <p>
                      <b>{billingContent?.billing_automated_billing_note}</b>{" "}
                      {billingContent?.billing_ebill_note_content}
                    </p>
                  </div>
                  {(billingPreference?.CurrentBillPref !== "P5" ||
                    billingPreference?.CurrentBillType !== "WEBPORTAL") && (
                    <div className="d-flex px-2">
                      <h6 tabIndex={0} className="d-inline mt-3 me-xl-4 me-md-4 me-0 electronicDelivery">
                        {billingContent?.billing_ebill_inactive_text}
                      </h6>
                      {!readOnlyMode && (
                        <button
                          className={`btn ${switchBillPaperButton()} btn-lg ms-xl-3 ms-md-3 ms-0`}
                          onClick={handleEBillModal}
                        >
                          {Payload?.owning_carrier !== 'Q5' && (
                          <i className="fe fe-repeat fe-17 align-middle me-1"></i>
                        )}
                          {billingContent?.billing_switch_to_ebill}
                        </button>
                      )}
                    </div>
                  )}
                </div>
                {Payload?.owning_carrier !== "Q5" && (
                  <div className="col-xl-6 col-md-5 col-12 text-xl-center">
                    <img
                      src={ebillImgSrc}
                      style={{ width: "220px" }}
                      className="mw-100"
                      alt="ebill"
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          {activeKey === "tab3" && (
            <div
              ref={tab3Ref}
              tabIndex="-1"
              style={{ outline: 'none' }}
              className="tab-pane fade show"
              id="nav-Paper"
              role="tabpanel"
              aria-labelledby="nav-Paper-tab"
              aria-label="Paper Bill Content"
              onKeyDown={(e) => {
                    if (e.key === 'Tab' && e.shiftKey) {
                      e.preventDefault();
                      document.getElementById('nav-Paper-tab')?.focus();
                    }
                  }}
            >
              <div className="col-12 d-xl-flex d-md-flex d-sm-block d-block">
                <div
                  className={
                    Payload?.owning_carrier === "Q5"
                      ? "col-xl-12 col-sm-12 col-12"
                      : "col-xl-6 col-md-7 col-sm-12 col-12"
                  }
                >
                  {billingPrefErrorFlag && (
                    <div className="api-error-msg">
                      {genericContent?.billing_pref_info_service_error}
                    </div>
                  )}
                  {isPrefLoading && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        margin: "inherit",
                      }}
                    >
                      <Spinner animation="border" role="status"></Spinner>
                      <div style={{ fontSize: "12px" }}>
                        {genericContent?.loading_message}
                      </div>
                    </div>
                  )}
                  {!isPrefLoading && !billingPrefErrorFlag && (
                    <div tabIndex={0} className="mb-3">
                      <img src={zapIcon} className="me-2" alt="zap" />
                      <h6 className="d-inline">
                        {billingContent?.billing_current_preference}{" "}
                        {getCurrentBilling(currentBilling)}
                      </h6>
                    </div>
                  )}
                  <div tabIndex={0} className="grey-bg rounded px-4 py-4 mb-4">
                    <p>
                      <b>{billingContent?.billing_automated_billing_note}</b>{" "}
                      {billingContent?.billing_paper_note_content}
                    </p>
                  </div>
                  {billingPreference?.CurrentBillType !== "PAPER" && (
                    <div className="d-flex px-2">
                      <h6 tabIndex={0} className="d-inline mt-3 me-xl-4 me-md-4 me-0">
                        {billingContent?.billing_paper_inactive_text}
                      </h6>
                      {!readOnlyMode && (
                        <button
                          className={`btn ${switchBillPaperButton()} btn-lg ms-xl-3 ms-md-3 ms-0`}
                          onClick={handlePaperModal}
                        >
                           {Payload?.owning_carrier !== 'Q5' && (
                          <i className="fe fe-repeat fe-17 align-middle me-1"></i>
                        )}
                          {billingContent?.billing_switch_to_paper}
                        </button>
                      )}
                    </div>
                  )}
                </div>
                {Payload?.owning_carrier !== "Q5" && (
                  <div className="col-xl-6 col-md-5 col-12 text-xl-center">
                    <img src={paperImgSrc} className="mw-100" alt="paperbill" />
                  </div>
                )}
              </div>
            </div>
          )}
          </div>
          </div>
        </Modal.Body>
        </div>
        </>
    );
};

export default BillingPreference;